export const generateQueryString = (params: { [key: string]: string }) => {
    const queryParamsInstance = new URLSearchParams(params);
    return queryParamsInstance.toString();
};
